namespace $ {
	export class $visavis_graph extends $mol_book2 {
		
		/**
		 * ```tree
		 * plot $visavis_plot
		 * ```
		 */
		@ $mol_mem
		plot() {
			const obj = new this.$.$visavis_plot()
			
			return obj
		}
		
		/**
		 * ```tree
		 * pages / <= Plot
		 * ```
		 */
		pages() {
			return [
				this.Plot()
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * plot_title \
		 * ```
		 */
		plot_title() {
			return ""
		}
		
		/**
		 * ```tree
		 * draw null
		 * ```
		 */
		draw() {
			return null as any
		}
		
		/**
		 * ```tree
		 * Root $mol_view auto <= draw
		 * ```
		 */
		@ $mol_mem
		Root() {
			const obj = new this.$.$mol_view()
			
			obj.auto = () => this.draw()
			
			return obj
		}
		
		/**
		 * ```tree
		 * plot_body / <= Root
		 * ```
		 */
		plot_body() {
			return [
				this.Root()
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * Plot $mol_page
		 * 	title <= plot_title
		 * 	body <= plot_body
		 * ```
		 */
		@ $mol_mem
		Plot() {
			const obj = new this.$.$mol_page()
			
			obj.title = () => this.plot_title()
			obj.body = () => this.plot_body()
			
			return obj
		}
	}
	
}

